import { get } from '@/request/request'

export default {
    index(params) {
        return get('/admin/report/index', params)
    },

}